module.exports = __webpack_public_path__ + "img/shape5.f8fce463.png";